/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ReportingPreset } from 'src/app/model';
import { ReportingPresetProvider } from 'src/app/providers';
import { ReportingService } from 'src/app/services';

@Component({
  selector: 'app-create-preset-modal',
  templateUrl: './create-preset.modal.html',
  styleUrls: ['./create-preset.modal.scss']
})

export class CreatePresetModal implements OnInit, OnDestroy {
  subject: Subject<ReportingPreset>;
  subscription: any;
  confirmationModal: BsModalRef;
  preset: ReportingPreset = new ReportingPreset();

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private reportingPresetProvider: ReportingPresetProvider,
    private reportingService: ReportingService
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onSubmit(): void {
    this.preset.QUERY = {
      FILTER: this.reportingService.getFilter(),
      DISPLAY: this.reportingService.getDisplay(),
      ORDER: this.reportingService.getOrder()
    };
    this.reportingPresetProvider.savePreset(this.preset)
      .subscribe(
        data => {
          if (data.success) {
            this.bsModalRef.hide();
            this.subject.next(ReportingPreset.parse(data.result));
            this.subject.complete();
          }
        });
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }
}
